import { render, staticRenderFns } from "./BuildManagement.vue?vue&type=template&id=04e1113e&scoped=true"
import script from "./BuildManagement.vue?vue&type=script&lang=js"
export * from "./BuildManagement.vue?vue&type=script&lang=js"
import style0 from "./BuildManagement.vue?vue&type=style&index=0&id=04e1113e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e1113e",
  null
  
)

export default component.exports